export default __webpack_public_path__ + "static/media/Pumkin GIF.e3b4f9e2.1199bcdb.gif";